import React from "react";

export const OutageNotice = () => (
  <>
    <h1>Hent gavekortet ditt</h1>
    <p>
      GoGift har for tiden tekniske problemer. Send en e-post til{" "}
      <a href="mailto:elin.svensen@uis.no">elin.svensen@uis.no</a>, så får du
      beskjed når problemene er løst og du kan hente gavekortet i appen.
    </p>
  </>
);
